// Group a day's exercises into supersets so the UI can bracket them together.
// A "superset" is 2+ consecutive exercises that share the same leading letter
// in their group code (A1 + A2, B1 + B2 + B3, …). A lone code (just A1) or an
// exercise with no code renders on its own.

export interface SupersetGroup<T> {
  /** Leading letter shared by the group (e.g. "A"), or null when uncoded. */
  letter: string | null
  /** True only when this letter brackets 2+ exercises → a real superset. */
  superset: boolean
  items: { ex: T; index: number }[]
}

const letterOf = (group?: string | null): string | null => {
  const m = (group ?? '').trim().match(/^[A-Za-z]+/)
  return m ? m[0].toUpperCase() : null
}

export function groupSupersets<T extends { group?: string | null }>(
  exercises: T[]
): SupersetGroup<T>[] {
  const groups: SupersetGroup<T>[] = []
  exercises.forEach((ex, index) => {
    const letter = letterOf(ex.group)
    const last = groups[groups.length - 1]
    if (letter && last && last.letter === letter) {
      last.items.push({ ex, index })
    } else {
      groups.push({ letter, superset: false, items: [{ ex, index }] })
    }
  })
  for (const g of groups) g.superset = g.letter != null && g.items.length > 1
  return groups
}
